import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
  ElementRef
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { RoomService } from "../../services/room.service";
import { Log } from "./models/log.model";
import { UserService } from "../../services/user.service";

export interface Logs {
  template: string;
  label: string;
}

@Component({
  selector: "app-log",
  templateUrl: "./log.component.html",
  styleUrls: ["./log.component.scss"]
})
export class LogComponent implements OnInit {
  @ViewChild("scrollMe", { static: true })
  private myScrollContainer: ElementRef;

  private searchControl: FormControl;

  @Input()
  openLogs: boolean;

  @Output()
  openLogsChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  _logs: Logs[];
  @Input()
  set logs(logs: Logs[]) {
    this._logs = logs;
    this.scrollToBottom();
  }

  get logs(): Logs[] {
    return this._logs;
  }

  @Output()
  logsInputChanges: EventEmitter<Logs> = new EventEmitter<Logs>();

  public notesText: string;
  private notesModelChanged: Subject<string> = new Subject<string>();
  private notesModelChangeSubscription: Subscription;

  constructor(
    private roomService: RoomService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.searchControl = new FormControl("");
  }

  close() {
    this.openLogs = !this.openLogs;
    this.openLogsChange.emit(this.openLogs);
  }

  sendTapedText() {
    const log: Log = {
      prefix: `${this.userService.user.displayName}:`,
      template: "chat",
      label: this.searchControl.value
    };
    /* this.logsInputChanges.emit(log); */
    this.roomService.updateRoomLogs(this.roomService.roomId, log);
    this.searchControl.setValue(null);
    this.scrollToBottom();
  }

  // todo improve in angular way
  scrollToBottom(): void {
    let objDiv = document.getElementById("logs");
    if (objDiv) {
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  }
}
